import type { ManagedCustomDashboardTab } from '@/lib/api/custom-dashboard';
import { isActiveDataUpdateStatus } from './dataUpdateJobStatus';

/** データ更新を始められない理由。 */
export type DataUpdateBlocker = 'no-active-revision' | 'no-details' | 'running';

/** ボタンの title に出す理由。 */
export const DATA_UPDATE_BLOCKER_REASONS: Record<DataUpdateBlocker, string> = {
  'no-active-revision': '公開中の revision がないため更新できません',
  'no-details': 'details.txt がアップロードされていません',
  running: 'このタブは更新中です',
};

/** データ更新の欄に常に見せる短い理由（実行中は状態そのものを出すため持たない）。 */
export const DATA_UPDATE_BLOCKER_HINTS: Record<Exclude<DataUpdateBlocker, 'running'>, string> = {
  'no-active-revision': '公開後に利用できます',
  'no-details': 'details.txt がありません',
};

/** データ更新を始められなければその理由を返す（details.txt を持つ ready な active revision が必要）。 */
export function dataUpdateBlocker(tab: ManagedCustomDashboardTab): DataUpdateBlocker | null {
  if (tab.activeRevision === null) return 'no-active-revision';
  if (!tab.activeRevisionHasDetails) return 'no-details';
  if (tab.latestDataUpdate !== null && isActiveDataUpdateStatus(tab.latestDataUpdate.status)) {
    return 'running';
  }
  return null;
}
